module.exports = __webpack_public_path__ + "static/media/heavy_pound02.362fd01b.jpg";